export const environment = {
  PROD: false,
  maintenance: false,
  maintenanceTime: '',
  TIME_UNTIL_EXPIRY_MINUTES: 5,
  TIME_COUNTDOWN_MINUTES: 3,
  TIME_PING_SECONDS: 30,
  TIME_PING_RETRY_SECONDS: 10,
  TIMEOUT_SECONDS: 60,
  LINEAR_FORMS: false,
  // Deployed version, injected by CI (sed) right before `ng build`.
  version: '3.4.4',
  versionDate: '2026-10-16T06:54:09Z',
  // Campo «Dirección»: mapa Leaflet para confirmar la ubicación. Las teselas
  // vienen de OpenStreetMap (atribución obligatoria); URL configurable por ambiente.
  mapa: {
    tileUrl: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    maxZoom: 19,
    // Centro por defecto: Valle del Cauca.
    centroDefecto: { latitud: 3.9, longitud: -76.55 },
    zoomDepartamento: 8,
    zoomMunicipio: 13,
    zoomDireccion: 17,
  },
};
